<template>
    <!-- 数据统计---交易数据统计页面 -->
    <div class="page">
        <!-- 提示信息 -->
        <div class="tip">
            <i class="iconfont iconjinggao"></i>
            <span>本页面数据仅供经营状况参考，不计退款，不代表账单信息，请勿用作对账。</span>
        </div>
        <!-- 顶部时间筛选 -->
        <Search :datePicker="datePicker" @selectTime="getTimeFn" @resetForm="resetForm" @submitForm="submitForm" />
        <!-- echars图标 -->
        <div class="wrap">
            <blue-title>{{ title[0] }}</blue-title>
            <!-- <AreaChat :datePicker="datePicker" /> -->
            <div class="area">
                <!-- 顶部提示 -->
                <div class="top">
                    <div class="box_row box">
                        <div v-for="(item, index) in titleList" :key="index" :class="activeIndex === index ? 'active' : ''" @click="changeActive(index)">
                            {{ item.label }}
                            <i class="el-icon-caret-bottom" :style="activeIndex === index ? '' : 'display:none'"></i>
                        </div>
                    </div>
                    <div class="time">
                        <span></span>
                        <p>{{datePicker[0]}}至{{datePicker[1]}}</p>
                    </div>
                </div>
                <div id="line"></div>
            </div>
        </div>
        <div class="wrap">
            <div class="wrapFlex">
                <blue-title>{{ title[1] }}</blue-title>
                <div class="wrapBtn">
                    <span v-for="(item,index) in titleList" :key="index" :class="active===index?'active':''" @click="selectOption(index)">{{item.label}}</span>
                </div>
            </div>
            <div style="display:flex;">
                <div id="pieChat"></div>
                <div id="barChat"></div>
            </div>
            <!-- <PieChat></PieChat> -->
        </div>
    </div>
</template>

<script>
import { getDayAll } from '@/util/date.js';
import Search from '@statistics/components/search';
// import AreaChat from '@statistics/components/areaChat';
import { titleName } from '@statistics/static/data.js';
import { formatDate } from '@/util/date.js';
import { mapState, mapActions } from 'vuex';
// import PieChat from '../components/pieChat.vue';

export default {
  name: 'statistics',
  // provide() {
  //   return {
  //     submitForm: this.changeSearch,
  //   };
  // },
  components: {
    Search,
    // AreaChat,
    // PieChat,
  },
  computed: {
    title() {
      return titleName.get(this.$route.name);
    },
    // routeName() {
    //   return this.$route.name === 'statistics/interface';
    // },
    // ...mapGetters('statistics', ['payPrices']),
    ...mapState({
      statisticsList: (state) => state.statistics.statisticsList,
      totalAmount: (state) => state.statistics.totalAmount,
    }),
  },
  data() {
    return {
      payStates: [],
      titleList: [{ label: '交易订单金额' }, { label: '交易订单量' }],
      active: 0,
      datePicker: [],
      form: {
        startTime: '',
        endTime: '',
        applyCode: JSON.parse(localStorage.getItem('checkdApply')).applyCode,
      },
      activeIndex: 0,
      pieOption: {},
      payPrice: [],
      refundPrice: [],
    };
  },
  mounted() {
    this.getTimeFn(1);
    this.form.startTime = this.datePicker[0];
    this.form.endTime = this.datePicker[1];
    this.getPayStates(this.activeIndex); //折线图
    this.getStaStates(this.active); //饼图 柱状图
  },
  methods: {
    ...mapActions('statistics', ['getStatistics']),
    // 时间查询
    changeSearch(datePicker) {
      console.log(datePicker);
      this.datePicker = datePicker;
    },
    /**
     * 设置默认时间为一周
     */
    getTimeFn(index) {
      const end = new Date();
      const start = new Date();
      if (index === 0) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
      } else if (index === 1) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      } else if (index === 2) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      }
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
      this.datePicker = [formatDate(start), formatDate(end)];
      console.log(this.datePicker);
      this.getPayStates(this.activeIndex);
    },

    submitForm(datePicker) {
      this.datePicker = datePicker;
      this.form.startTime = datePicker[0];
      this.form.endTime = datePicker[1];
      this.getPayStates(this.activeIndex);
    },
    //重置
    resetForm() {
      this.getTimeFn(1);
    },
    selectOption(e) {
      this.active = e;
      this.getStaStates(this.active); //饼图 柱状图
    },
    // 更改标题
    changeActive(index) {
      this.activeIndex = index;
      this.getPayStates(this.activeIndex);
    },
    getPayStates(index) {
      this.getStatistics(this.form).then((res) => {
        this.payStates = res.result.map((item) => {
          if (index === 0) {
            return item.payPrices;
          } else {
            return item.payCount;
          }
        });
        this.areaChat();
      });
    },
    getStaStates() {
      this.getStatistics(this.form).then((res) => {
        this.pieOption = {
          aliPercentage: res.aliPercentage, //支付宝百分比
          wechatPercentage: res.wechatPercentage, //微信百分比
          aggregationPercentage: res.aggregationPercentage, //聚合百分比
        };
        if (this.active === 0) {
          this.payPrice = [res.wechatSumPayPrices, res.aliSumPayPrices, res.aggregationSumPayPrices];
          this.refundPrice = [res.wechatSumRefundPrices, res.aliSumRefundPrices, res.aggregationSumRefundPrices];
        } else {
          this.payPrice = [res.wechatSumPayNum, res.aliSumPayNum, res.aggregationSumNum];
          this.refundPrice = [res.wechatSumRefundNum, res.aliSumRefundNum, res.aggregationSumRefundNum];
        }

        this.getPieChat();
        this.getBarChat();
      });
    },
    areaChat() {
      let option = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: getDayAll(this.datePicker[0], this.datePicker[1]),
        },
        yAxis: {
          type: 'value',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
          },
        },
        series: [
          {
            data: this.payStates,
            type: 'line',
            color: '#4359B7',
            areaStyle: {
              color: '#4359B7',
            },
            smooth: true,
          },
        ],
      };
      this.$echarts.init(document.getElementById('line')).setOption(option);
    },
    getPieChat() {
      let option = {
        tooltip: {
          trigger: 'item',
        },
        legend: {
          icon: 'circle',
          itemWidth: 10,
          itemHeight: 10,
          bottom: 'bottom',
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: [
              { value: this.pieOption.aliPercentage, name: '支付宝', itemStyle: { color: '#4359B7' } },
              { value: this.pieOption.wechatPercentage, name: '微信', itemStyle: { color: '#43AAB7' } },
              { value: this.pieOption.aggregationPercentage, name: '聚合', itemStyle: { color: '#FF9F07' } },
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
              normal: {
                label: {
                  show: true,
                  formatter: '{d}%',
                },
                labelLine: { show: true },
              },
            },
          },
        ],
      };
      this.$echarts.init(document.getElementById('pieChat')).setOption(option);
    },
    getBarChat() {
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          data: ['支付', '退款'],
          icon: 'circle',
          itemWidth: 10,
          itemHeight: 10,
          bottom: 'bottom',
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
        },
        xAxis: {
          type: 'category',
          data: ['微信', '支付宝', '聚合'],
        },
        series: [
          {
            name: '支付',
            type: 'bar',
            data: this.payPrice,
            itemStyle: { color: '#72BFC9', barBorderRadius: [5, 5, 0, 0] },
            barWidth: 10,
          },
          {
            name: '退款',
            type: 'bar',
            data: this.refundPrice,
            itemStyle: { color: '#FF5F5F', barBorderRadius: [5, 5, 0, 0] },
            barWidth: 10,
          },
        ],
      };
      this.$echarts.init(document.getElementById('barChat')).setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.tip {
  padding: 5px 20px 20px;
  span {
    color: 14px;
    color: #666;
    padding-left: 5px;
  }
}

.wrap {
  width: 100%;
  height: 489px;
  background: @bg-white;
  margin-top: 10px;
  padding: 20px 0px;
}
.iconjinggao {
  color: #4359b7;
  width: 15px;
  height: 15px;
}
.wrapFlex {
  display: flex;
  justify-content: space-between;
  .wrapBtn {
    margin-right: 30px;
    span {
      display: inline-block;
      padding: 10px 20px;
      background: #f8f8f8;
      margin: 0 8px;
    }
    .active {
      background: #4359b7;
      color: #fff;
    }
  }
}
.area {
  padding: 24px 90px 40px 50px;
}
.top {
  .flex_layout(row, space-between);
  .time {
    display: flex;
    color: #666;
    span {
      width: 14px;
      height: 14px;
      margin-right: 12px;
      border-radius: 50%;
      background: #43aab7;
    }
  }
}

.box {
  div {
    position: relative;
    padding: 14px 15px;
    font-size: 15px;
    border-radius: 5px 0px 0px 0px;
    cursor: pointer;
  }
  div:last-child {
    background: #f8f8f8;
    border-radius: 0px 5px 0px 0px;
    color: #333333;
  }
  .active {
    background: #4359b7 !important;
    color: #fff !important;
  }
  .el-icon-caret-bottom {
    position: absolute;
    bottom: -9px;
    left: 48%;
    color: #4359b7;
  }
}
#line {
  width: 100%;
  height: 380px;
}
#pieChat,
#barChat {
  width: 49%;
  height: 400px;
}
</style>
